import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * SimpleLineChart — minimalna wizualizacja trendu liniowego (SVG).
 * Nie wymaga zewnętrznej biblioteki wykresów.
 */
function SimpleLineChart({ data = [], label, height = 120, color: lineColor }) {
  const theme = useTheme();
  const chartColor = lineColor || theme.palette.primary.main;

  if (!data.length) return null;

  const max = Math.max(...data.map((d) => d.value));
  const min = Math.min(...data.map((d) => d.value));
  const range = max - min || 1;
  const padding = 8;
  const w = 100;
  const h = height - padding * 2;

  const points = data.map((d, i) => {
    const x = (i / (data.length - 1)) * w;
    const y = h - ((d.value - min) / range) * h + padding;
    return `${x},${y}`;
  });

  const polyline = points.join(' ');
  const areaPoints = `0,${h + padding} ${polyline} ${w},${h + padding}`;

  return (
    <Box>
      {label && (
        <Typography variant="caption" color="text.secondary" sx={{ mb: 1, display: 'block' }}>
          {label}
        </Typography>
      )}
      <Box sx={{ width: '100%', height }}>
        <svg
          viewBox={`0 0 ${w} ${height}`}
          preserveAspectRatio="none"
          style={{ width: '100%', height: '100%' }}
        >
          <defs>
            <linearGradient id="chartGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={chartColor} stopOpacity="0.2" />
              <stop offset="100%" stopColor={chartColor} stopOpacity="0.02" />
            </linearGradient>
          </defs>
          <polygon points={areaPoints} fill="url(#chartGradient)" />
          <polyline
            points={polyline}
            fill="none"
            stroke={chartColor}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      </Box>
      {data.length > 0 && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 0.5 }}>
          <Typography variant="caption" color="text.secondary">{data[0].label}</Typography>
          <Typography variant="caption" color="text.secondary">{data[data.length - 1].label}</Typography>
        </Box>
      )}
    </Box>
  );
}

export default SimpleLineChart;
